var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddcomments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #4a4a4a;\r\n        opacity: 0.163;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #707070;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13384",
    "data-name": "Group 13384",
    transform: "translate(-2207 27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9143",
    "data-name": "Ellipse 9143",
    className: "cls-1",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(2207 -27)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13376",
    "data-name": "Group 13376",
    transform: "translate(40 11.866)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4439",
    "data-name": "Line 4439",
    className: "cls-2",
    x2: 6.134,
    transform: "translate(2178.5 -26.433)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4440",
    "data-name": "Line 4440",
    className: "cls-2",
    x2: 6.134,
    transform: "translate(2181.567 -29.5) rotate(90)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_4441",
    "data-name": "Line 4441",
    className: "cls-2",
    x2: 8,
    transform: "translate(2211.5 -20.5)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4442",
    "data-name": "Line 4442",
    className: "cls-2",
    x2: 8,
    transform: "translate(2211.5 -17.5)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4443",
    "data-name": "Line 4443",
    className: "cls-2",
    x2: 5,
    transform: "translate(2211.5 -14.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcomments);
export default __webpack_public_path__ + "static/media/add comments.45b2ec03c2240c923183d96c21588cc3.svg";
export { ForwardRef as ReactComponent };